import { applyMiddleware, Middleware } from 'redux';

import createComposer from './createComposer';

const createEnhancer = (...middleware: Middleware<any, any, any>[]) =>
  createComposer()(applyMiddleware(...middleware));

export default createEnhancer;
